import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import English from '@/components/i18n/en/en';
import French from '@/components/i18n/fr/fr';
import Spanish from '@/components/i18n/sp/sp';

const resources = {
  English: {
    translation: English,
  },
  French: {
    translation: French,
  },
  Spanish: {
    translation: Spanish,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'English',  
    fallbackLng: 'English', 
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
